import { CmmFileTypes } from '../../../shared/types/cmmConfig.ts';
import { CmmConfig, CustomEquipment } from '../../types/sharedTypeImpl.ts';
import { doesExtensionMatch } from './doesExtensionMatch.ts';
import { fileToTable } from './fileToTable.ts';
import { readCmmPositions } from './readCmmPositions.ts';
import { resolveCmmEquipment } from './resolveCmmEquipment.ts';
import { CmmFileRead } from './types.ts';


export async function readCmmFile(
    file: File,
    cmmConfigs: CmmConfig[],
    options?: { ignoreInvalidPosNr?: boolean },
    cmmEquipments: CustomEquipment[] = [],
): Promise<CmmFileRead> {
    // Filter cmmConfigs by file extension
    const cmmFileType = CmmFileTypes.find(it => doesExtensionMatch(file.name, it.id));
    if (!cmmFileType) {
        return {
            success: false,
            errorMessage: `File type not supported: "${file.name}".`,
        };
    }

    // Read the file into a table
    let table;
    try {
        table = await fileToTable(file, cmmFileType.id);
    } catch (error: any) {
        return {
            success: false,
            errorMessage: `Error reading file "${file.name}": ${error.message}`,
        };
    }

    // Resolve cmmConfig
    const resolveResult = resolveCmmEquipment(table, file, cmmFileType.id, cmmConfigs, cmmEquipments);
    if (!resolveResult.success) {
        return {
            success: false,
            errorMessage: resolveResult.errorMessage,
        }
    }

    // Get position values from the table
    const { cmmConfig, cmmConfigMetadata, cmmEquipment, warningMessage } = resolveResult;
    const positions = readCmmPositions(table, cmmConfig, cmmConfigMetadata.firstPositionsRow, options);

    return {
        success: true,
        equipmentId: cmmEquipment._id,
        warningMessage,
        hasMultipleParts: cmmConfigMetadata.hasMultipleParts,
        positions,
    };
}
